import { getOperatorsByQueryType, searchInStaticData, getFileSizes } from './helper'

const inOperator = {
  group: '',
  queryType: 'inOperator',
  type: 'operator',
  options: []
}

const userLabel = {
  group: '',
  queryType: 'userLabel',
  type: 'key',
  options: [
    { label: 'Created By', value: 'created_by' },
    { label: 'Updated By', value: 'updated_by' },
    { label: 'Published By', value: '_published_by' }
  ]
}

const inUser = {
  group: '',
  queryType: 'userLabel',
  type: 'value',
  options: []
}

//text type
export const uidLabel = {
  group: '',
  queryType: 'uidLabel',
  type: 'key',
  options: [{ label: 'UID', value: 'uid' }]
}

const dateLabel = {
  group: '',
  queryType: 'dateLabel',
  type: 'key',
  options: [
    { label: 'Created At', value: 'created_at' },
    { label: 'Updated At', value: 'updated_at' },
    { label: 'Published At', value: '_published_at' }
  ]
}

const environmentLabel = {
  group: '',
  queryType: 'environmentLabel',
  type: 'key',
  options: [{ label: 'Published Environment', value: '_publish_environment' }]
}

const inEnvironment = {
  group: '',
  queryType: 'environmentLabel',
  type: 'value',
  options: []
}

export const fileNameLabel = {
  group: '',
  //textType
  queryType: 'fileNameLabel',
  type: 'key',
  options: [{ label: 'File Name', value: 'filename' }]
}

//number
export const fileSizeLabel = {
  group: '',
  queryType: 'fileSizeLabel',
  type: 'key',
  options: [{ label: 'File Size', value: 'file_size' }]
}

const inFileSize = {
  group: '',
  queryType: 'fileSizeLabel',
  type: 'value',
  options: []
}

//text type
export const urlLabel = {
  group: '',
  queryType: 'urlLabel',
  type: 'key',
  options: [{ label: 'URL', value: 'url' }]
}

const assetTagLabel = {
  group: '',
  queryType: 'assetTagLabel',
  type: 'key',
  options: [{ label: 'Tag', value: 'tags' }]
}

const inAssetTag = {
  group: '',
  queryType: 'assetTagLabel',
  type: 'value',
  options: []
}

const typeLabel = {
  group: '',
  queryType: 'typeLabel',
  type: 'key',
  options: [{ label: 'Type', value: '_content_type_uid' }]
}

const inType = {
  group: '',
  queryType: 'typeLabel',
  type: 'value',
  options: []
}

//text type
export const titleLabel = {
  group: '',
  queryType: 'titleLabel',
  type: 'key',
  options: [{ label: 'Title', value: 'title' }]
}

const advSearchTextLabel = {
  group: '',
  queryType: 'advSearchTextLabel',
  type: 'key',
  options: [{ label: 'Text', value: 'search' }]
}

export const suggestForAssets = async (data) => {
  try {
    let { queryType, fetchData, inputValue = '', skip, limit, currentQuery, type, ct_status } = data
    const { key = [], operator = [], value = [] } = currentQuery
    // console.log('suggestForEntries ~ data:', data)

    let queryData: any = []
    let withOperator = true
    let count = 0
    let operators = getOperatorsByQueryType(queryType, key)
    let afterKey = false

    if ((type === 'operator' || type === 'value') && !key.length) {
      return { queryData: [], count: 0 }
    }

    //init case
    //init case
    if (type === 'key') {
      let staticQueryData = [
        advSearchTextLabel,
        userLabel,
        fileNameLabel,
        fileSizeLabel,
        titleLabel,
        urlLabel,
        dateLabel,
        typeLabel,
        environmentLabel,
        assetTagLabel,
        uidLabel
      ]

      if (inputValue.trim() === '') {
        return { queryData: staticQueryData, count: staticQueryData.length, withOperator }
      } else {
        let searchResponse = searchInStaticData(staticQueryData, inputValue)
        return { queryData: searchResponse.data, count: searchResponse.count, withOperator }
      }
    }

    if (type === 'operator') {
      queryData = [{ ...inOperator, options: operators }]
      count = operators.length
      return { queryData, count, withOperator }
    }

    switch (queryType) {
      case 'environmentLabel': {
        const response: any = await fetchData.fetchEnvironments({ skip, limit, inputValue })
        inEnvironment.options = response.data
        count = response.count
        queryData = [inEnvironment]
        withOperator = true
        break
      }

      // case 'fileSizeLabel': {
      //   let num: any = parseInt(inputValue) || parseFloat(inputValue)

      //   num = num || ''
      //   const fileSizeOptions = getFileSizes({ inputValue: num })
      //   inFileSize.options = fileSizeOptions
      //   count = 1
      //   queryData = [inFileSize]
      //   withOperator = true
      //   break
      // }

      case 'assetTagLabel': {
        const response: any = await fetchData.fetchAssetTags({ skip, limit, inputValue })
        let filteredTags = response.data

        // if (inputValue) {
        //   filteredTags = filteredTags.filter((tag) => {
        //     return tag.label.toLowerCase().includes(inputValue.toLowerCase())
        //   })
        // }
        // filteredTags = sortBy(filteredTags, (tag) => tag.label)

        inAssetTag.options = filteredTags
        count = response.count
        queryData = [inAssetTag]
        withOperator = true
        afterKey = response?.afterKey ? true : false
        break
      }

      case 'typeLabel': {
        const response: any = await fetchData.fetchAssetTypes({
          skip,
          limit,
          inputValue: inputValue || ''
        })
        inType.options = response.data
        count = response.count
        queryData = [inType]
        withOperator = true
        break
      }

      case 'userLabel': {
        const response: any = await fetchData.fetchUsers({ skip, limit, inputValue })
        inUser.options = response.data
        count = response.count
        queryData = [inUser]
        withOperator = true
        break
      }
    }

    return { withOperator, queryData, count, afterKey: afterKey }
  } catch (error) {
    console.log('suggestForAsset ~ error:', error)
    throw error
  }
}
